// app.module.ts
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { SelectionModule } from './pages/selection/selection.module';
import { CheckoutModule } from './pages/checkout/checkout.module';
import { StripeModule } from './pages/stripe/stripe.module';
import { SuccessModule } from './pages/success/success.module';
import { ReceiptModule } from './pages/receipt/receipt.module';
import { LoadingModule } from './components/loading/loading.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPrintModule } from 'ngx-print';


import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CheckoutModule,
    SuccessModule,
    SelectionModule,
    StripeModule,
    ReceiptModule,
    LoadingModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgxPrintModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
